import { RefObject, useEffect, useState } from 'react';

const isObserverSupported = () =>
  typeof IntersectionObserver !== 'undefined';

// Becomes true once the element nears the viewport and stays true.
export function useInView<T extends Element>(
  ref: RefObject<T | null>,
  { rootMargin = '200px' }: { rootMargin?: string } = {},
): boolean {
  const [inView, setInView] = useState(() => !isObserverSupported());

  useEffect(() => {
    const element = ref.current;
    if (inView || !element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );
    observer.observe(element);

    return () => observer.disconnect();
  }, [ref, rootMargin, inView]);

  return inView;
}

export default useInView;
